export default __webpack_public_path__ + "images/td-230eddd3b5d97166b70e47afed43a67f.svg";